import { __ } from "@wordpress/i18n";
import { useRulesContext } from "../../../../../hook/useRulesContext";
import { ChevronDown } from "lucide-react";

export default function BulkActions() {
    const { handleBulkActions, bulkAction, setBulkAction } = useRulesContext();

    return (
        <div className="flex items-center space-x-2">
            <div className="relative flex-1 sm:flex-initial">
                <select
                    value={bulkAction}
                    onChange={(e) => setBulkAction(e.target.value)}
                    className="appearance-none w-full max-w-none bg-white border border-gray-200 rounded-lg px-3 py-2 pr-8 text-sm"
                >
                    <option value="none">
                        {__(
                            "Bulk Actions",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                    </option>
                    <option value="trash">
                        {__(
                            "Move to Trash",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                    </option>
                    <option value="active">
                        {__(
                            "Mark as Active",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                    </option>
                    <option value="inactive">
                        {__(
                            "Mark as Inactive",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                    </option>
                </select>
                <ChevronDown className="absolute right-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
            </div>
            <button
                onClick={() => handleBulkActions(bulkAction)}
                className="px-3 py-2 bg-gray-200/80 text-gray-700 text-sm font-medium rounded-lg hover:bg-gray-300/80 transition-colors"
            >
                {__("Apply", "wpbean-quantity-controls-for-woocommerce")}
            </button>
        </div>
    );
}
